'use client'

import { Container } from 'react-bootstrap'
import parse from 'html-react-parser'

import { formatTitleWithItalic } from '@/utils'
import { cmsImageSrc } from '@/utils/cmsImageSrc'

function Features({ data }) {
  return (
    <Container fluid className="container feature">
      {data?.features?.map((item, index) => (
        <div
          key={item.title}
          className={`outer-box ${index % 2 === 0 ? 'row-direction' : 'row-reverse-direction'}`}
          data-aos={index % 2 === 0 ? 'fade-right' : 'fade-left'}
          data-aos-delay="150"
        >
          <div
            className="content-box"
            style={{
              textAlign: index % 2 === 0 ? 'right' : 'left'
            }}
          >
            <span>{formatTitleWithItalic(item?.tagline)}</span>
            <h3>{formatTitleWithItalic(item?.title)}</h3>
            {item?.description && parse(item?.description)}
          </div>
          <div className="coming-soon-image-container">
            <img
              src={cmsImageSrc(item?.image || item?.imageLink)}
              alt="Iphone Icon"
              className="d-block"
              width="100%"
            />
          </div>
        </div>
      ))}
    </Container>
  )
}

export default Features
